export const content = {
    domain: "Reprise Financial",
    footer: "reprisefrinancial.com",
    title1: "GET STARTED with your best loan",
  };
  